<template>
  <!-- Record Payment Modal -->
  <div class="modal custom-fade fade" id="payment_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div v-if="selectedItem" class="modal-content">
        <div class="modal-header border-0 pb-0">
          <div class="form-header modal-header-title text-start mb-0">
            <h4 class="mb-0">Record Payment</h4>
          </div>
          <button
            type="button"
            class="close"
            @click="$emit('closePaymentModal')"
            aria-label="Close"
          >
            <span class="align-center" aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="recordPayment">
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-4 col-md-12">
                <div class="form-group">
                  <label>Payment date</label><span class="text-danger">*</span>
                  <datepicker
                    v-model="form.date"
                    class="picker"
                    :editable="true"
                    :clearable="false"
                  />
                </div>
              </div>
              <div class="col-lg-12 col-md-12">
                <div class="form-group">
                  <label>Payment method</label>
                  <span class="text-danger">*</span>
                  <select v-model="form.method" class="form-select" required>
                    <option value="" selected>Select method</option>
                    <option value="cash">Cash</option>
                    <option value="bank_transfer">Bank transfer</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Amount paid</label> <span class="text-danger">*</span>
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <span style="font-size: 12px">NGN</span>
                    </b-input-group-prepend>
                    <b-form-input
                      type="number"
                      v-model="form.amount"
                      :max="selectedItem.amount_due"
                      min="1"
                      class="form-control"
                      name="amount"
                      id="amount"
                      placeholder="Enter Amount"
                      required
                    />
                  </b-input-group>
                </div>

                <div class="form-group">
                  <label
                    v-for="(channel, index) in channels"
                    :key="index"
                    class="custom_check me-3"
                    style="color: #878a99; margin-bottom: 8px"
                  >
                    <input
                      v-model="form.notify_channels"
                      :value="channel.value"
                      type="checkbox"
                    />
                    <span class="checkmark"></span>
                    <p class="mb-2" style="color: #878a99; font-weight: medium">
                      Send receipt to {{ channel.label }}
                      <strong class="text-black">{{
                      channel.label !== 'email' ? `${selectedItem.customer.country_code} ${channel.social}` : channel.social
                      }}</strong>
                    </p>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              @click="$emit('closePaymentModal')"
              class="btn btn-primary cancel me-2"
            >
              Cancel
            </button>
            <button type="submit" :disabled="isLoading" class="btn btn-primary">
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
              ></span>
              <span v-if="!isLoading">Record Payment</span>
              <span v-if="isLoading">Saving...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Record Payment Modal -->
</template>

<script setup>
import { ref,computed } from "vue";
import { useStore } from "vuex";
import { formatDateToDashDigits } from "@/assets/composables/date";

const store = useStore();
const isLoading = ref(false);
const props = defineProps({
  form: {
    type: Object,
  },
  selectedItem: {
    type: Object,
  },
});

const channels = computed(() => [
  { label: 'email', value:'mail', social: props.selectedItem.customer.email },
  { label: 'phone', value:'sms', social: props.selectedItem.customer.phone },
  { label: 'WhatsApp', value:'whatsapp', social: props.selectedItem.customer.whatsapp_number },
])

const emit = defineEmits(["closePaymentModal"]);

const recordPayment = async () => {
  isLoading.value = true;
  let payload = {
    invoice_id: props.form.invoice_id,
    date: formatDateToDashDigits(props.form.date),
    method: props.form.method,
    amount: props.form.amount,
    notify_client: props.form.notify_client
  };
  if (props.form.notify_channels.length > 0) {
    payload.notify_client = true
    payload.notify_channels = props.form.notify_channels
  }
  await store
    .dispatch("invoices/recordPayment", payload)
    .then(() => {
      emit("closePaymentModal");
      isLoading.value = false;
    })
    .catch(() => {
      emit("closePaymentModal");
      isLoading.value = false;
    });
};
</script>
